export default "__VITE_ASSET__C0YgzwQ5__"